import { Component, Vue } from 'vue-property-decorator';
import LevelUpsTable from '@/components/pages/contribution-levels/level-ups-table/LevelUpsTable.vue';
import Statistics from '@/components/pages/contribution-levels/statistics/Statistics.vue';

@Component({
  components: {
    LevelUpsTable,
    Statistics
  }
})
export default class ContributionLevels extends Vue { }